module.exports = __webpack_public_path__ + "img/lottery_en_bg.b2dffc06.png";